(function () {
    angular.module('app')
        .component('lazyPartial', {
            bindings: {
                pageId: '<',
                partial: '@',
                disableDefaultReveal: '<?',
                onReady: '&?',
                headerTitle: '@'
            },
            template: `
                <div class="content"></div>
                <div class="placeholder" ng-transclude></div>
            `,
            transclude: true,
            controller: LazyPartialController
        });

    LazyPartialController.$inject = ['lazyPartialService', '$element', '$compile', '$scope', '$timeout'];
    function LazyPartialController(lazyPartialService, $element, $compile, $scope, $timeout) {
        var ctrl = this;
        ctrl.$onInit = function () {
            ctrl._content = $element.find('> .content');
            ctrl._placeholder = $element.find('> .placeholder');
            lazyPartialService.getPartial(ctrl.pageId, ctrl.partial)
                .then(function (response) {
                    ctrl._content.html(response.data.replace('[headertitle]', ctrl.headerTitle));
                    $compile(ctrl._content)($scope);
                    $timeout(function () {
                        $element.addClass('ready');
                        if (ctrl.onReady) {
                            ctrl.onReady({
                                id: ctrl.id,
                                element: $element,
                                partial: ctrl.partial
                            });
                        }
                        if (!ctrl.disableDefaultReveal) {
                            new TimelineLite()
                                .to(ctrl._placeholder, .4, { autoAlpha: 0 })
                                .fromTo(ctrl._content, .5, { autoAlpha: 0, y: -20 }, { delay: .2, autoAlpha: 1, y: 0 })
                                .set(ctrl._content, { clearProps: 'transform' });
                        }
                    });
                })
                .catch(function (error) {
                    console.log(error);
                    $element.append('<p class="warning">Failed to load partial.</p>');
                });
        };
    }
})();